import styled from 'styled-components';

export const BackgroundContainer = styled.div<{
	$imageUrl: string;
	$backgroundOpacity: number;
}>`
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background-image: url(${(props) => props.$imageUrl});
	background-size: cover;
	background-position: center;
	background-repeat: no-repeat;
	transition: opacity 2s ease-in-out;
	opacity: ${(props) => props.$backgroundOpacity};
`;

export const StyledHeader = styled.header<{ $isHomePage: boolean }>`
	width: 100%;
	background-color: transparent;

	position: relative;

	transition: height 0.25s ease;

	@media (max-width: 768px) {
		height: 24vh;
	}

	@media (min-width: 769px) {
		height: ${(props) => (props.$isHomePage ? '36vh' : '24vh')};
	}
`;
